(function () {
  // Reparations ARIA que le theme ne peut pas faire lui-meme, parce que Slick et Swiper
  // reecrivent le DOM apres le rendu serveur.
  //
  // 1. Slick deplace les <li> des vignettes produit dans .slick-track : le <ul> se retrouve
  //    avec des <button> et un <div> en enfants directs, et les <li> n'ont plus de liste
  //    parente. On rend le <ul> presentationnel et on porte la semantique sur la piste.
  // 2. Le theme pose role="list" sur des conteneurs de grille qui contiennent des <img>,
  //    des titres ou des liens directs. Un role="list" sans listitem casse la restitution
  //    vocale : on le retire, le conteneur redevient un simple bloc.

  function estListitem(el) {
    var r = el.getAttribute("role");
    return el.tagName === "LI" || r === "listitem" || r === "presentation" || r === "none";
  }

  function passe() {
    document.querySelectorAll("ul.thumbnail-list").forEach(function (ul) {
      var piste = ul.querySelector(":scope > .slick-list > .slick-track");
      if (!piste) return;
      ul.setAttribute("role", "presentation");
      if (piste.getAttribute("role") !== "list") piste.setAttribute("role", "list");
    });

    // 3. Swiper pose role="group" sur ses diapositives. Quand la piste est un vrai <ul>,
    //    ces <li> cessent d'etre des elements de liste et la liste devient invalide.
    //    On retire le role, l'etiquette "1 / 4" reste.
    document.querySelectorAll("ul.swiper-wrapper > li[role=group], ol.swiper-wrapper > li[role=group]").forEach(
      function (li) { li.removeAttribute("role"); }
    );

    document.querySelectorAll('[role="list"]').forEach(function (n) {
      if (n.tagName === "UL" || n.tagName === "OL") return;
      var enfants = Array.prototype.filter.call(n.children, function (c) {
        return c.tagName !== "SCRIPT" && c.tagName !== "STYLE" && c.tagName !== "TEMPLATE";
      });
      if (!enfants.length) return;
      var tous = enfants.every(estListitem);
      if (!tous) n.removeAttribute("role");
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", passe);
  else passe();
  // Slick et Swiper finissent leur initialisation apres le premier passage.
  setTimeout(passe, 1200);
  setTimeout(passe, 3500);
  setTimeout(passe, 7000);
})();

(function () {
  // Les descriptions produit (678 fiches, toutes langues) portent des <h4> directement sous le
  // titre d onglet <h2> : saut de niveau. Corrige dans le DOM plutot que dans 678 corps de fiche.
  function niveaux() {
    document.querySelectorAll(".product-description h4").forEach(function (h4) {
      var h3 = document.createElement("h3");
      for (var i = 0; i < h4.attributes.length; i++) h3.setAttribute(h4.attributes[i].name, h4.attributes[i].value);
      h3.className = (h3.className ? h3.className + " " : "") + "abn-h4";
      while (h4.firstChild) h3.appendChild(h4.firstChild);
      h4.parentNode.replaceChild(h3, h4);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", niveaux);
  else niveaux();
})();

(function () {
  // Fenetre de formulaire d une app tierce : ni nom accessible sur le dialogue ni contraste
  // suffisant sur les libelles flottants (3,19:1). Corrige cote theme, sans toucher a l app.
  var CSS = '[class*="_formInputFieldLabel_"]{color:#5c5c5c!important}';
  function racine(r) {
    if (!r || r.__abnA11y) return;
    r.__abnA11y = 1;
    try {
      var st = document.createElement("style");
      st.textContent = CSS;
      r.appendChild(st);
    } catch (e) {}
  }
  function nommer(r) {
    r.querySelectorAll('[role="dialog"]:not([aria-label]):not([aria-labelledby])').forEach(function (d) {
      var t = d.querySelector("h1,h2,h3,[class*='heading'],[class*='title']");
      var txt = t && t.textContent.trim();
      d.setAttribute("aria-label", txt || (document.documentElement.lang === "fr" ? "Inscription" : "Sign up"));
    });
  }
  function passe() {
    nommer(document);
    document.querySelectorAll("shopify-forms-embed").forEach(function (h) {
      if (h.shadowRoot) { racine(h.shadowRoot); nommer(h.shadowRoot); }
    });
  }
  racine(document.head);
  passe();
  new MutationObserver(passe).observe(document.documentElement, { childList: true, subtree: true });
})();
